import { OrgAdminConstants } from '../../../_constants';

const initialState = { getMemberLevelLoading: true, data: '', error: false };

export function getMemberLevel(state = initialState, action) {
    
    switch (action.type) {
        case OrgAdminConstants.REQUEST_MEMBER_LEVEL:
            return {
                getMemberLevelLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_MEMBER_LEVEL:
            return {
                getMemberLevelLoading: false,
                data: action.getMemberLevel,
                error: false
            };
        case OrgAdminConstants.MEMBER_LEVEL_ERROR:
            return {
                getMemberLevelLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/MemberLevel/getMemberLevel.reducer.js